<div class="message">
  <form class="form" autocomplete="off" novalidate [formGroup]="form" (submit)="submit()">
    @if (!threadMessageId()) {
      <!-- SMS MODE only -->
      @if (isSMSChat()) {
        <div class="form__sms-container">
          <div class="sms-mode">
            <div class="circle"></div>
            <span class="sms-text">{{ 'messageCenter.smsMode' | translate }}</span>
            <span class="text-only">{{ 'messageCenter.textOnly' | translate }}</span>
          </div>
  
          <div class="quick-replies">
            <span class="label">{{ 'messageCenter.quickReplies' | translate }}</span>
            <div class="replies">
              @for (reply of quickReplies; track reply) {
                @let translatedReply = reply | translate;
                <button
                  class="app-button"
                  type="button"
                  (click)="form.controls.message.setValue(translatedReply)">
                  {{ translatedReply }}
                </button>
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="form__channels-container">
          <div class="channels">
            @if (!threadIsOpened()) {
              <span class="send-via">{{ 'messageCenter.sendVia' | translate }}</span>
            }
    
            <button
              class="app-button"
              type="button"
              [class.internal-active]="isInternalMessage"
              (click)="changeMessageType(MessageType.internal)">
              <mat-icon>chat</mat-icon>
              {{ 'messageCenter.messageType_text' | translate }}
            </button>
    
            <button
              class="app-button"
              type="button"
              [class.sms-active]="isSmsMessage"
              (click)="changeMessageType(MessageType.sms)">
              <mat-icon>sms</mat-icon>
              {{ 'messageCenter.messageType_sms' | translate }}
            </button>
    
            <button
              class="app-button"
              type="button"
              [class.email-active]="isEmailMessage"
              (click)="changeMessageType(MessageType.email)">
              <mat-icon>mail</mat-icon>
              {{ 'messageCenter.messageType_email' | translate }}
            </button>
          </div>
    
          <span class="channel-description">
            @switch (form.controls.channel.value) {
              @case (MessageType.internal) {
                {{ 'messageCenter.internalMessages_description' | translate }}
              }
              @case (MessageType.sms) {
                {{ 'messageCenter.smsMessages_description' | translate }}
              }
              @case (MessageType.email) {
                {{ 'messageCenter.emailMessages_description' | translate }}
              }
            }
          </span>
        </div>

        @if (isEmailMessage) {
          <div class="form__subject-container">
            <input
              appTrimInput
              class="form-control"
              type="text"
              formControlName="subject"
              [placeholder]="'messageCenter.subjectPlaceholder' | translate">
          </div>
        }
      }
    }

    <div class="form__input-container">
      @if (!isSmsMessage && !isSMSChat()) {
        <app-file-upload
          type="icon"
          (filesChanged)="addFiles($event)">
        </app-file-upload>
      }

      <div class="input-with-files">
        <textarea
          appTrimInput
          class="form-control"
          formControlName="message"
          autocomplete="off"
          maxlength="1000"
          rows="1"
          [placeholder]="'messageCenter.messageInputPlaceholder' | translate"
        ></textarea>

        @if (loadedFiles.length) {
          <div class="files">
            @for (file of loadedFiles; track fileIndex; let fileIndex = $index) {
              <div class="file">
                <mat-icon class="icon-close" (click)="removeAttachedFile(fileIndex)">close</mat-icon>
                <span class="file-name">{{ file.name }}</span>
              </div>
            }
          </div>
        }
      </div>

      @if (isSmsMessage || isSMSChat()) {
        <span
          class="chars-limit"
          [class.invalid]="form.controls.message.value?.length > maxSMSMessageLength">
          {{ form.controls.message.value.length }}/{{ maxSMSMessageLength }}
        </span>
      }

      <button
        class="app-button app-button_spinner"
        [class.internal-active]="isInternalMessage"
        [class.sms-active]="isSmsMessage || isSMSChat()"
        [class.email-active]="isEmailMessage"
        [disabled]="!form.valid || isSending()">
        @if (isSending()) {
          <app-loading size="extra_small"></app-loading>
        }
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </form>
</div>
